import { QueryClient } from "@tanstack/react-query";
import { forgetPracticeAudio } from "./practiceApi";
import { forgetGeneratedStoriesProgress } from "./readingProgress";

// createSignedInUserSync returns the function to call with the uid (null when
// signed out) on every auth state change, so that one user's client state
// doesn't leak to the next one on this device.
// When the signed-in user changes (sign-out, sign-in, account switch), the
// query cache is reset - mounted views refetch for the new user, showing
// nothing of the previous one meanwhile - and practice audio is released.
// Reading progress of generated stories goes whenever nobody or someone else
// is signed in. The first auth event of a page load only restores the
// persisted session and resets nothing: user-specific requests wait for it,
// so nothing was cached for anyone else and nothing needs a refetch.
export function createSignedInUserSync(queryClient: QueryClient) {
  let signedInUid: string | null | undefined; // undefined before the first event
  return (uid: string | null) => {
    const userChanged = signedInUid !== undefined && uid !== signedInUid;
    signedInUid = uid;
    if (userChanged) {
      queryClient.resetQueries();
      queryClient.removeQueries({ type: "inactive" });
      forgetPracticeAudio();
    }
    if (userChanged || uid === null) {
      forgetGeneratedStoriesProgress();
    }
  };
}
